import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {ScanDocumentRulesListItemDto} from "../../api/cms";

class CmsRulesListStore {
    get customerId(): string {
        return this._customerId;
    }

    set customerId(value: string) {
        this._customerId = value;
    }
    get items(): ScanDocumentRulesListItemDto[] {
        return this._items
    }

    set items(value: ScanDocumentRulesListItemDto[]) {
        this._items = value
    }

    get pages(): number {
        return this._pages
    }

    set pages(value: number) {
        this._pages = value
    }

    get page(): number {
        return this._page
    }

    set page(value: number) {
        this._page = value
    }

    get size(): number {
        return this._size
    }

    set size(value: number) {
        this._size = value
    }

    private _items: ScanDocumentRulesListItemDto[] = []
    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25
    private _customerId: string = ''

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const response = await catchApi(async () =>
            await api.cms.api.listScanDocumentRules(
                this.customerId,
                {
                    page: this.page - 1,
                    size: this.size
                    },
                {}
            ))
        const responseData = response!!.data
        this.pages = responseData.totalPages || 0
        this.items = responseData.items || []
    }
}

const cmsRulesListStore = new CmsRulesListStore()

export {
    cmsRulesListStore
}
